module.exports = __webpack_public_path__ + "static/media/lxnmj.5a86f0f1.png";